import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateContentTestDto } from '@inference.engine/persona-api-client';

import { CONTENT_TEST_QUERY_KEYS } from '../api/query-keys';
import { createContentTest } from '../api/content-test.api';

export const useCreateContentTest = (workspaceId: string | null | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateContentTestDto) => createContentTest(workspaceId!, payload),
    onSuccess: () => {
      if (workspaceId) {
        void queryClient.invalidateQueries({ queryKey: CONTENT_TEST_QUERY_KEYS.list(workspaceId) });
      }
    },
  });
};
